module.exports = __webpack_public_path__ + "img/img-a1056598.c180d5cd.png";